import useSWR from "swr";

import getFacetCounts from "../Filters/getFacetCounts";
import { MappedFacetCounts, FacetType } from "../Filters/filters.type";
import getBuyerAPIDomain from "../APICalls/getBuyerAPIDomain";
import { PurchasesUrlQueryParams } from "../APICalls/buildGetPurchasesUrl";
import { useMemo } from "react";

export function useCurrentFacet(
  currentFacet: FacetType | null,
  purchasesUrlParams: PurchasesUrlQueryParams,
  isToUseAuthZero: boolean,
  accessToken: string | undefined
) {
  const buyerAPIDomain = getBuyerAPIDomain(isToUseAuthZero);
  const getFacetCountUrl = buyerAPIDomain
    ? new URL(
        `${buyerAPIDomain.href}/saleresults/facets?currentFacet=${currentFacet}`,
        buyerAPIDomain
      )
    : null;

  const appliedFilters =
    "bq" in purchasesUrlParams.additionalFilters
      ? purchasesUrlParams.additionalFilters["bq"].split("|")
      : null;
  if (getFacetCountUrl && appliedFilters?.length > 0) {
    const valToAppend = appliedFilters
      .filter((item) => !item.includes(`${currentFacet}:`))
      .join("|");
    if (valToAppend?.length > 0) {
      getFacetCountUrl.searchParams.append("bq", valToAppend as string);
    }
  }

  const freeSearchText = purchasesUrlParams.q;
  if (freeSearchText) {
    getFacetCountUrl.searchParams.append("q", freeSearchText as string);
  }

  getFacetCountUrl.searchParams.set(
    "numberofDays",
    purchasesUrlParams.numberofDays
  );

  const swrKey = useMemo(() => {
    if (isToUseAuthZero && !accessToken) {
      return null;
    }

    return currentFacet
      ? [getFacetCountUrl.href, accessToken, isToUseAuthZero]
      : [
          getFacetCountUrl.href.replace("null", "Make"),
          accessToken,
          isToUseAuthZero,
        ];
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isToUseAuthZero, accessToken, currentFacet]);

  const {
    data: facetCounts,
    error: facetCountsError,
    mutate: mutateCurrentFacet,
  } = useSWR<{ counts: MappedFacetCounts[]; totalResults: number }>(
    swrKey,
    getFacetCounts,
    {
      revalidateOnFocus: false,
      shouldRetryOnError: false,
    }
  );

  return {
    facetCounts,
    facetCountsError,
    mutateCurrentFacet,
  };
}
